import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {getCookie} from "../helpers/utils";

@Injectable({
  providedIn: 'root'
})
export class SuperUserMethodsService {

  private _commonPrefix: string = '/api/v1/'
  private _venuesAcquireListURL: string = `${this._commonPrefix}place/`;
  private _gamesTypesAcquireURL: string = `${this._commonPrefix}game/`;
  private _categoryAcquireURL: string = `${this._commonPrefix}rating_status/`;
  private _postTournamentDataUrl: string = `${this._commonPrefix}user_tournament/`;
  private selectedJudgesIdList: Array<number> = [];
  private gameSeparator = ', ';
  private venueSeparator = ', ';
  private categorySeparator = ', ';

  private formAKey = (separator : string, ...stringsToConcat : string[]) => {
    return stringsToConcat.join(separator);
  };

  constructor(private http: HttpClient) { }


  get csrfToken() :string {
    return getCookie('csrftoken');
  }

  get gamesTypesURL() {
    return this._gamesTypesAcquireURL;
  }

  get categoryURL() {
    return this._categoryAcquireURL;
  }

  get venuesURL() {
    return this._venuesAcquireListURL;
  }

  get postTournamentDataURL() {
    return this._postTournamentDataUrl;
  }

  acquireGamesTypes() {
    return this.http.get(this.gamesTypesURL);
  }

  acquireCategories() {
    return this.http.get(this.categoryURL);
  }

  acquireVenues() {
    return this.http.get(this.venuesURL);
  }

  transformRawListOfGameTypesToRender(GameTypesList: Array<GameType>): Map<string, number> {
    const mapToReturn = new Map<string, number>();
    GameTypesList.forEach((gameType) => {
      mapToReturn.set(
        this.formAKey(
          this.gameSeparator,
          gameType.name, gameType.game_type
        ),
        gameType.id
      );
    });
    return mapToReturn;
  }

  transformRawListOfCategoriesToRender(CategoriesList: Array<Category>): Map<string, number> {
    const mapToReturn = new Map<string, number>();
    CategoriesList.forEach((category) => {
      mapToReturn.set(
        this.formAKey(
          this.categorySeparator,
          category.title
        ),
        category.id
      );
    });
    return mapToReturn;
  }

  transformRawListOFVenuesToRender(VenuesList: Array<Venue>): Map<string, number> {
    const mapToReturn = new Map<string, number>();

    VenuesList.forEach((venue) => {
      mapToReturn.set(
        this.formAKey(
          this.venueSeparator,
          venue.name, venue.country, venue.city
        ),
        venue.id
      );
    });

    return mapToReturn;
  }

  setJudgesIdList(list: number[]) {
    this.selectedJudgesIdList = [...list];
  }

  getJudgesIdList(): number[] {
    return this.selectedJudgesIdList;
  }

  appendNewJudgeId(id: number) {
    this.selectedJudgesIdList.push(id);
  }

  sendTournamentData(data: FormData) {
    return this.http.post(this.postTournamentDataURL,
      data, {
        headers: {
          'X-CSRFToken': this.csrfToken,
        }
      }
    );
  }

}

export interface GameType {
  id: number,
  name: string,
  game_type: string,
}

export interface Venue {
  id: number,
  name: string,
  country: string,
  city: string,
}

export interface Date {
  year: number,
  month: number,
  day: number,
}

export interface Time {
  hour: number,
  minute: number,
  second: number,
}

export interface TournamentData {
  name: string,
  start_at: string,
  place: number,
  game: number,
  regulations_file: string,
  judges: number[],
}

export interface Category {
  id: number,
  title: string,
}

